"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base class of meta component.
 */
var React = require("react");
var NativeDOMAdapter_1 = require("./NativeDOMAdapter");
var BaseMeta = (function (_super) {
    __extends(BaseMeta, _super);
    function BaseMeta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseMeta.prototype.render = function () {
        var children = this.props.children;
        var props = this.renderProps(children.props);
        var nativeDOMProps = this.renderNativeDOMProps(children.props);
        return (React.createElement(NativeDOMAdapter_1.default, __assign({}, nativeDOMProps), React.cloneElement(children, props)));
    };
    return BaseMeta;
}(React.Component));
exports.default = BaseMeta;
//# sourceMappingURL=MetaBase.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/base/lib/MetaBase.js
// module id = ./node_modules/@react-mdc/base/lib/MetaBase.js
// module chunks = 1 2 3